import Header from "./component/header";
import AboutUs from "./page/about-us";
import ContactUs from "./page/contact-us";
import Home from "./page/home";

function App() {
  const onScroll = (activeContainer) => {
    const element = document.getElementById(activeContainer);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
  return (
    <div className="App">
      <Header handleMenuClick={onScroll} />
      <div id="home" className="container">
        <Home />
      </div>
      <div id="about-us" className="container">
        <AboutUs />
      </div>
      {/* contact us & footer */}
      <div id="contact-us" className="container">
        <ContactUs />
      </div>
    </div>
  );
}

export default App;
